import * as Popover from '@radix-ui/react-popover';
import { IncentiveCampaign } from 'containers/IncentiveCampaign';
import { useIncentiveCampaign } from 'containers/IncentiveCampaign/hooks/useIncentiveCampaign';
import { Flex, Skeleton } from 'front-commons/ds';
import { useResponsive } from 'front-commons/hooks';
import { Typography } from 'hype-ds';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { selectContentGTM } from 'shared/gtm';
import { StyledButton } from './styles';

export function IncentiveCampaignHeader() {
	const [open, setOpen] = useState(false);

	const navigate = useNavigate();
	const { medium } = useResponsive();
	const { data, isFetching, progress } = useIncentiveCampaign();

	function handleClick() {
		selectContentGTM('header_menu', 'Bateu, Ganhou');
		navigate('/bateu-ganhou');
	}

	if (isFetching) {
		return <Skeleton maxWidth="100px" height="26px" />;
	}

	return (
		<Popover.Root open={open && medium} onOpenChange={setOpen}>
			<StyledButton
				data-testid="header-nav-item-bateu-ganhou"
				onClick={handleClick}
				onMouseEnter={() => setOpen(true)}
				onMouseLeave={() => setOpen(false)}
			>
				<Typography.Label.M color="--text-link">Bateu, Ganhou</Typography.Label.M>
			</StyledButton>

			{data && (
				<Popover.Portal>
					<Popover.Content
						side="bottom"
						align="start"
						sideOffset={2}
						onMouseEnter={() => setOpen(true)}
						onMouseLeave={() => setOpen(false)}
						style={{ outline: 'none' }}
					>
						<IncentiveCampaign.Root
							maxWidth="352px"
							gap="1rem"
							raw={{ outline: 'none', boxShadow: '0px 4px 8px 0px var(--greys-1000-25)' }}
						>
							<IncentiveCampaign.Title
								// @ts-ignore
								as={Typography.Heading.XS}
								content={data.name}
								slotProps={{
									tooltip: {
										side: 'right',
									},
								}}
							>
								{data.name.textEllipsis(28)}
							</IncentiveCampaign.Title>

							{data.description && (
								<IncentiveCampaign.Description
									// @ts-ignore
									as={Typography.Paragraph.S}
									content={data.description}
									slotProps={{
										tooltip: {
											side: 'right',
										},
									}}
								>
									{data.description.textEllipsis(94)}
								</IncentiveCampaign.Description>
							)}

							<Flex gap="3.5rem">
								<IncentiveCampaign.CompletedChallenges
									slotProps={{
										label: {
											// @ts-ignore
											as: Typography.Paragraph.S,
										},
									}}
								>
									{progress}
								</IncentiveCampaign.CompletedChallenges>

								<IncentiveCampaign.ActiveChallenges
									slotProps={{
										label: {
											// @ts-ignore
											as: Typography.Paragraph.S,
										},
									}}
								>
									{data.packagesQuantity}
								</IncentiveCampaign.ActiveChallenges>
							</Flex>

							<IncentiveCampaign.Dates endDate={data.endDate} startDate={data.startDate} />
						</IncentiveCampaign.Root>
					</Popover.Content>
				</Popover.Portal>
			)}
		</Popover.Root>
	);
}
